<template>
<!-- Modal สร้างผู้ใช้งาน -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">+ สร้างผู้ใช้งาน</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="">
                    <div class="form-card">
                        <div class="row g-4">
                            <!-- Left Section -->
                            <div class="col-lg-6">
                                <div class="form-section">
                                    <h5 class="section-title mb-4">
                                        <i class="bi bi-info-circle me-2"></i>ข้อมูลผู้ใช้งาน
                                    </h5>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-person me-2"></i>ชื่อผู้ใช้งาน
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter username" v-model="username">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-envelope me-2"></i>อีเมล
                                        </label>
                                        <input type="email" class="custom-input" placeholder="example@email.com" v-model="email">
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 mb-4">
                                            <label class="custom-label">
                                                <i class="bi bi-card-text me-2"></i>ชื่อ
                                            </label>
                                            <input type="text" class="custom-input" placeholder="First name" v-model="firstName">
                                        </div>

                                        <div class="col-md-6 mb-4">
                                            <label class="custom-label">
                                                <i class="bi bi-card-text me-2"></i>นามสกุล
                                            </label>
                                            <input type="text" class="custom-input" placeholder="Last name" v-model="lastName">
                                        </div>
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-shield-check me-2"></i>ระดับผู้ใช้งาน
                                        </label>
                                        <select class="custom-input" v-model="role">
                                            <option value="" disabled selected>Select a role</option>
                                            <option value="User">User</option>
                                            <option value="Operator">Operator</option>
                                            <option value="Admin">Admin</option>
                                            <option value="Owner" v-if="['Owner'].includes(userInfo.role)">Owner</option>
                                        </select>
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-lock me-2"></i>รหัสผ่าน
                                        </label>
                                        <input type="password" class="custom-input " placeholder="Enter secure password" v-model="password">
                                           <div class="text-danger" v-if="password!=confirmPassword&&confirmPassword!=''">กรุณากรอกรหัสผ่านให้ตรงกัน</div>  
                                        <label class="custom-label mt-2">
                                            <i class="bi bi-lock me-2"></i>ยืนยันรหัสผ่าน
                                        </label>
                                        <input type="password" class="custom-input" placeholder="Enter Confirm password" v-model="confirmPassword">
                                        <div class="text-danger" v-if="password!=confirmPassword&&confirmPassword!=''">กรุณากรอกรหัสผ่านให้ตรงกัน</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Section -->
                            <div class="col-lg-6">
                                <div class="form-section">
                                    <h5 class="section-title mb-4">
                                        <i class="bi bi-pencil-square me-2"></i>ข้อมูลเพิ่มเติม
                                    </h5>

                                    <!-- <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-chat-left-text me-2"></i>โน๊ต (ตัวเลือกเพิ่มเติม)
                                        </label>
                                        <textarea class="custom-input" rows="8" placeholder="รายละเอียดเพิ่มเติมของผู้ใช้งาน..." v-model="note"></textarea>
                                    </div> -->

                                    <!-- Info Box -->
                                    <div class="info-box">
                                        <i class="bi bi-lightbulb text-warning me-2"></i>
                                        <div>
                                            <strong>คำแนะนำ :</strong>
                                            <p class="mb-0 mt-1">
                                                ตรวจสอบให้แน่ใจว่าคุณใช้รหัสผ่านที่แข็งแกร่ง โดยมีอย่างน้อย 8 ตัวอักษร รวมทั้งตัวอักษร ตัวเลข และสัญลักษณ์</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="button-row mt-5">
                            <button @click="clearDataUser()" class="btn-clear">
                                <i class="bi bi-arrow-counterclockwise me-2"></i>Clear Form
                            </button>
              <button 
  @click="createUser()" 
  class="btn-create"
  :disabled="password!=confirmPassword&&confirmPassword!=''"
>
  <i class="bi bi-check-circle me-2"></i>Create User
</button>


                            <!-- <button @click="createUser()" class="btn-create" >
                                <i class="bi bi-check-circle me-2"></i>Create User
                            </button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal แก้ไขผู้ใช้งาน -->
<div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel"><i class="bi bi-pen me-2"></i>แก้ไขผู้ใช้งาน</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="">
                    <div class="form-card">
                        <div class="row g-4">
                            <!-- Left Section -->
                            <div class="col-lg-6">
                                <div class="form-section">
                                    <h5 class="section-title mb-4">
                                        <i class="bi bi-info-circle me-2"></i>ข้อมูลผู้ใช้งาน
                                    </h5>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-person me-2"></i>ชื่อผู้ใช้งาน
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter username" v-model="editData.username">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-envelope me-2"></i>อีเมล
                                        </label>
                                        <input type="email" class="custom-input" placeholder="example@email.com" v-model="editData.email">
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 mb-4">
                                            <label class="custom-label">
                                                <i class="bi bi-card-text me-2"></i>ชื่อ
                                            </label>
                                            <input type="text" class="custom-input" placeholder="First name" v-model="editData.firstName">
                                        </div>

                                        <div class="col-md-6 mb-4">
                                            <label class="custom-label">
                                                <i class="bi bi-card-text me-2"></i>นามสกุล
                                            </label>
                                            <input type="text" class="custom-input" placeholder="Last name" v-model="editData.lastName">
                                        </div>
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-shield-check me-2"></i>ระดับผู้ใช้งาน
                                        </label>
                                        <select class="custom-input" v-model="editData.role">
                                            <option value="" disabled>Select a role</option>
                                            <option value="User">User</option>
                                            <option value="Operator">Operator</option>
                                            <option value="Admin">Admin</option>
                                            <option value="Owner" v-if="['Owner'].includes(userInfo.role)">Owner</option>
                                        </select>
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-lock me-2"></i>รหัสผ่าน (เว้นว่างไว้หากไม่ต้องการเปลี่ยน)
                                        </label>
                                        <input type="password" class="custom-input" placeholder="Enter new password" v-model="editData.password">
                                        <div class="text-danger" v-if="editData.password!=editData.confirmPassword&&editData.confirmPassword!=null">กรุณากรอกรหัสผ่านให้ตรงกัน</div>
                                            <label class="custom-label">
                                            <i class="bi bi-lock me-2"></i>Confirm รหัสผ่าน (เว้นว่างไว้หากไม่ต้องการเปลี่ยน)
                                        </label>
                                        <input :disabled="editData.password.length==0" type="password" class="custom-input" placeholder="Enter Confirm password" v-model="editData.confirmPassword">
                                        <div class="text-danger" v-if="editData.password!=editData.confirmPassword&&editData.confirmPassword!=null">กรุณากรอกรหัสผ่านให้ตรงกัน</div>
                                    </div>
                                    
                                </div>
                            </div>

                            <!-- Right Section -->
                            <div class="col-lg-6">
                                <div class="form-section">
                                    <h5 class="section-title mb-4">
                                        <i class="bi bi-pencil-square me-2"></i>ข้อมูลเพิ่มเติม
                                    </h5>

                                    <!-- <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-chat-left-text me-2"></i>โน๊ต (ตัวเลือกเพิ่มเติม)
                                        </label>
                                        <textarea class="custom-input" rows="8" placeholder="รายละเอียดเพิ่มเติมของผู้ใช้งาน..." v-model="editData.note"></textarea>
                                    </div> -->

                                    <!-- Info Box -->
                                    <div class="info-box">
                                        <i class="bi bi-lightbulb text-warning me-2"></i>
                                        <div>
                                            <strong>คำแนะนำ :</strong>
                                            <p class="mb-0 mt-1">
                                                หากไม่ต้องการเปลี่ยนรหัสผ่าน ให้เว้นช่องรหัสผ่านว่างไว้ ระบบจะใช้รหัสผ่านเดิม</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="button-row mt-5">
                            <button type="button" class="btn-clear" data-bs-dismiss="modal">
                                <i class="bi bi-x-circle me-2"></i>ยกเลิก
                            </button>
                   <!-- {{ editData }} -->
         <button v-if="editData.password.length==0"
  @click="updateUser()" 
  class="btn-create"
>
  <i class="bi bi-check-circle me-2"></i>บันทึกการแก้ไข
</button>
   <button v-else 
  @click="updateUser()" 
  class="btn-create"
  :disabled="editData.password !== editData.confirmPassword && editData.confirmPassword !== null"
>
  <i class="bi bi-check-circle me-2"></i>บันทึกการแก้ไข
</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="dashboard">
    <!-- Header -->
    <header class="header">
        <div class="container">
            <div class="header-content">
                <h1>รายการผู้ใช้งาน</h1>
                <div class="search-box">
                    <button type="button" class="btn btn-dark px-3 rounded-5" data-bs-toggle="modal" data-bs-target="#exampleModal"> + สร้างผู้ใช้งาน</button>
                </div>
            </div>
        </div>
    </header>

    <!-- Main Content -->
    <div class="container main-content">
        <!-- Customers Table -->
        <div class="customers-section">
            <div class="section-header">
                  <div class="col-12">
                    <div class="" style="font-size: 20px;">ผู้ใช้งานทั้งหมด</div>
                    <div class="row mt-2">
                        <div class="col-6">
                            <div class="search-box">
                                <i class="bi bi-search"></i>
                               <input
                                v-model.trim="q"
                                @keyup.enter="reload"
                                type="search"
                                class="form-control rounded-5"
                                placeholder="ค้นหาชื่อแผน (กด Enter)"
                                style="max-width: 260px; min-width: 200px;"
                                />
                            </div>
                        </div>
                        <div class="col-6  ">
                            <div class="row justify-content-end align-items-center me-2">
                                 <select v-model.number="size" class="form-select col-6" style="width: 120px;">
                                    <option :value="10">10 / หน้า</option>
                                    <option :value="20">20 / หน้า</option>
                                    <option :value="50">50 / หน้า</option>
                                    </select>
                                    <button class="btn btn-outline-dark col-2 ms-2" :disabled="loading" @click="reload">
                                    {{ loading ? "กำลังโหลด..." : "รีเฟรช" }}
                                    </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-wrapper">
                <table class="customers-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>ชื่อผู้ใช้งาน</th>
                            <th>ชื่อ-สกุล</th>
                            <th>สิทธ์การเข้าถึง</th>
                            <th>อีเมล</th>
                            <th>สร้างเมื่อ</th>
                            <th>แก้ไข/ลบ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(person, index) in users" :key="index">
                            <td class="text-center">{{ index+1 }}</td>
                            <td>{{ person.username }}</td>
                            <td>{{ person.firstName}} {{ person.lastName}}</td>
                            <td>{{ person.role }}</td>
                            <td>{{ person.email }}</td>
                            <td>{{  formatIsoToBangkok(person.createdAt) }}</td>
                            <td>
                                <span class="edit_btn px-1 py-1 rounded-2" @click="openEditModal(person)" data-bs-toggle="modal" data-bs-target="#editModal" style="cursor: pointer;">
                                    <i class="bi bi-pen"></i> แก้ไข
                                </span>
                                <span type="button" @click="deleteUser(person.id)" class="remove_btn px-3 py-1 rounded-2 ms-2">
                                    <i class="bi bi-trash3"></i> ลบ
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="pagination">
                <div class="pagination-info">
                    <!-- Showing data 1 to 8 of 256K entries -->
                </div>
                <div class="pagination-controls">
                    <button class="page-btn" @click="prevPage" :disabled="currentPage === 1">
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <button v-for="page in visiblePages" :key="page" :class="['page-btn', { active: currentPage === page }]" @click="currentPage = page">
                        {{ page }}
                    </button>
                    <button class="page-btn" v-if="totalPages > 5">...</button>
                    <button class="page-btn" @click="currentPage = 40">40</button>
                    <button class="page-btn" @click="nextPage" :disabled="currentPage === totalPages">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as bootstrap from 'bootstrap';
export default {
    data() {
        return {
            groupId:"",
            user_data_current: {},
            users: [],
            userInfo: {
                username: "",
                role: ""
            },
            loading: false,
            q: "",
            page: 1,
            size: 10,
            total: 0,
            // ข้อมูลสำหรับสร้าง user
            username: "",
            email: "",
            firstName: "",
            lastName: "",
            role: "",
            password: "",
            confirmPassword:null,
            note: "",
            // ข้อมูลสำหรับแก้ไข user
            editData: {
                id: "",
                username: "",
                email: "",
                firstName: "",
                lastName: "",
                role: "",
                password: '',
                confirmPassword:'',
                note: ""
            }
        };
    },
    computed: {
        disableNext() {
            return this.page * this.size >= this.total;
        },
    },
    mounted() {
        this.fetchUsers();
        this.getUserProfile()
    },
    methods: {
        clearDataUser() {
            this.email = "";
            this.username = "";
            this.firstName = "";
            this.lastName = "";
            this.role = "";
            this.password = "";
            this.note = "";
        },
        
        openEditModal(user) {
            // กำหนดข้อมูลผู้ใช้ที่จะแก้ไขลงใน editData
            this.editData = {
                id: user.id,
                username: user.username,
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                role: user.role,
                password: "", // เว้นว่างไว้เพื่อให้ผู้ใช้กรอกใหม่หากต้องการเปลี่ยน
                note: user.note || ""
            };
        },
        formatIsoToBangkok(isoString, locale = 'th-TH') {
  const d = new Date(isoString)
  // ใช้ toLocaleString พร้อม option สำหรับวันที่ + เวลา
  return d.toLocaleString(locale, {
    timeZone: 'Asia/Bangkok',
    year: 'numeric',
    month: 'short', // 'short' = ต.ค. หรือ '2-digit' / 'numeric' ตามชอบ
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}   ,
        
        async updateUser() {
            try {
                var accessToken = localStorage.getItem("accessToken");
                
                // ตรวจสอบว่ามีการกรอกรหัสผ่านหรือไม่
                const requestBody = {
                    "id": this.editData.id,
                    "username": this.editData.username,
                    "email": this.editData.email,
                    "firstName": this.editData.firstName,
                    "lastName": this.editData.lastName,
                    "role": this.editData.role
                };
                
                // ถ้ามีการกรอกรหัสผ่านใหม่ ให้เพิ่ม password และ confirmPassword
                if (this.editData.password && this.editData.password.trim() !== "") {
                    requestBody.password = this.editData.password;
                    requestBody.confirmPassword = this.editData.confirmPassword;
                }
                
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users/admin`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(requestBody)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                console.log('User updated:', result);
                
                // ปิด modal และรีเฟรชข้อมูล
                const editModal = bootstrap.Modal.getInstance(document.getElementById('editModal'));
                if (editModal) {
                    editModal.hide();
                }
                
                // รีเฟรชรายการผู้ใช้
                await this.fetchUsers();
                
                // แจ้งเตือนความสำเร็จ
                alert('แก้ไขข้อมูลผู้ใช้สำเร็จ');
                
            } catch (error) {
                console.error('Error updating user:', error);
                alert('เกิดข้อผิดพลาดในการแก้ไขข้อมูลผู้ใช้');
            }
        },
        
        async createUser() {
            var  userData;
            var pathLink;
            try {
           
                var role = localStorage.getItem("role");
                if(role=="Owner"){
                   pathLink="/auth/signup";
                    userData = {
                        "username": this.username,
                        "email": this.email,
                        "password": this.password,
                        "confirmPassword": this.confirmPassword,
                        "firstName": this.firstName,
                        "lastName": this.lastName,
                        "role": this.role
                    };  
                }else{
                    pathLink="/auth/user";
                     userData = {
                        "groupId": this.groupId,
                        "username": this.username,
                        "email": this.email,
                        "password": this.password,
                        "confirmPassword": this.confirmPassword,
                        "firstName": this.firstName,
                        "lastName": this.lastName,
                        "role": this.role
                    };
                }
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}${pathLink}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(
                    userData )
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                console.log('User created:', result);
                
                // ปิด modal และรีเฟรชข้อมูล
                const createModal = bootstrap.Modal.getInstance(document.getElementById('exampleModal'));
                if (createModal) {
                    createModal.hide();
                }
                
                this.clearDataUser();
                await this.fetchUsers();
                
                alert('สร้างผู้ใช้สำเร็จ');
                
            } catch (error) {
                console.error('Error creating user:', error);
                alert('เกิดข้อผิดพลาดในการสร้างผู้ใช้');
            }
        },

           async getUserProfile() {
            var accessToken = localStorage.getItem("accessToken");
            fetch(`${process.env.VUE_APP_API_URL}/api/users`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
            .then(response => response.json())
            .then(data => {
                this.groupId = data.data.groups[0]?.id || "";
            })
            .catch(error => {
                console.error('Error fetching user profile:', error);
            });
        },
        async fetchUsers() {
            try {
                this.loading = true;
                var accessToken = localStorage.getItem("accessToken");
                console.log("accessToken:", accessToken);
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users/all`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                console.log("Response status:", response.status);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                this.users = data.data;
                this.total = data?.meta?.total ?? this.users.length;
            } catch (error) {
                this.users = [];
                console.error('Error fetching dashboard data user:', error);
            } finally {
                this.loading = false;
            }
        },

        async deleteUser(id) {
            if (!confirm('คุณแน่ใจหรือไม่ที่จะลบผู้ใช้นี้?')) {
                return;
            }
            
            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users?userid=` + id, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                await this.fetchUsers();
                alert('ลบผู้ใช้สำเร็จ');
                
            } catch (error) {
                console.error('Error deleting user:', error);
                alert('เกิดข้อผิดพลาดในการลบผู้ใช้');
            }
        },

        reload() {
            this.page = 1;
            this.fetchUsers()
        },
        nextPage() {
            if (!this.disableNext) {
                this.page++;
                this.fetchUsers()
            }
        },
        prevPage() {
            if (this.page > 1) {
                this.page--;
                this.fetchUsers()
            }
        },
    },
    created() {
        this.userInfo.username = localStorage.getItem("username");
        this.userInfo.role = localStorage.getItem("role");
        this.fetchUsers()
    }
};
</script>

<style scoped>
.edit_btn {
    background: #d4f4dd;
    color: #00ac4f;
    border: 1px solid #00ac4f;
}

.remove_btn {
    background: #ffe2e5;
    color: #fa5a7d;
    border: 1px solid #fa5a7d;
}

.dashboard {
    min-height: 100vh;
    background-color: #f5f6fa;

}

.header {
    background: white;
    padding: 20px 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 0px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: #1a1a1a;
}

.search-box {
    position: relative;
    width: 300px;
}

.search-box input {
    width: 100%;
    padding: 10px 10px 10px 40px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    background: #f9fafb;
    outline: none;
}

.search-box input:focus {
    border-color: #6366f1;
}

.search-box i {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
}

.main-content {
    padding-top: 40px;
    padding-bottom: 40px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-bottom: 40px;
}

.stat-card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s;
}

.stat-card:hover {
    transform: translateY(-2px);
}

.stat-content {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;
}

.icon-green {
    background: #d4f4dd;
    color: #00ac4f;
}

.icon-purple {
    background: #e5d9f2;
    color: #8b5cf6;
}

.stat-info {
    flex: 1;
}

.stat-label {
    color: #9ca3af;
    font-size: 14px;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 32px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 8px 0;
}

.stat-change {
    font-size: 13px;
    font-weight: 500;
}

.change-up {
    color: #00ac4f;
}

.change-down {
    color: #fa5a7d;
}

.avatar-group {
    display: flex;
    margin-top: 8px;
}

.avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid white;
    margin-left: -8px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.avatar:first-child {
    margin-left: 0;
}

.customers-section {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.section-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px 0;
}

.active-members {
    color: #16c098;
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
}

.search-sort-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.sort-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
}

.sort-wrapper label {
    color: #9ca3af;
    font-size: 14px;
    margin: 0;
}

.sort-select {
    padding: 8px 16px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    color: #6b7280;
    background: white;
    cursor: pointer;
    outline: none;
}

.sort-select:focus {
    border-color: #6366f1;
}

.table-wrapper {
    overflow-x: auto;
}

.customers-table {
    width: 100%;
    min-width: 1100px;
    border-collapse: separate;
    border-spacing: 0;
}

.customers-table thead th {
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #e5e7eb;
}

.customers-table tbody td {
    padding: 16px;
    font-size: 14px;
    color: #1a1a1a;
    border-bottom: 1px solid #f3f4f6;
}

.customers-table tbody tr:hover {
    background: #f9fafb;
}

.status-badge {
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    display: inline-block;
    min-width: 70px;
    text-align: center;
}

.status-active {
    background: #d4f4dd;
    color: #00ac4f;
    border: 1px solid #00ac4f;
}

.status-inactive {
    background: #ffe2e5;
    color: #fa5a7d;
    border: 1px solid #fa5a7d;
}

.pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e5e7eb;
}

.pagination-info {
    color: #9ca3af;
    font-size: 14px;
}

.pagination-controls {
    display: flex;
    gap: 8px;
}

.page-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #e5e7eb;
    background: white;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    color: #6b7280;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    border-color: #6366f1;
    color: #6366f1;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-btn.active {
    background: #6366f1;
    color: white;
    border-color: #6366f1;
}

@media (max-width: 768px) {
    .stats-grid {
        grid-template-columns: 1fr;
    }

    .search-sort-bar {
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
    }

    .search-box {
        width: 100%;
    }

    .table-wrapper {
        overflow-x: scroll;
    }
}
</style >

<style scoped>
/* Global styles - ใส่ใน main.css หรือ App.vue */
@import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.0/font/bootstrap-icons.css');

* {
    box-sizing: border-box;
}

body {
    margin: 0;
    padding: 0;
}

/* Header Card */
.header-card {
    background: linear-gradient(135deg, #66b3ea 0%, #4b68a2 100%);
    padding: 2rem;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
    color: white;
}

.icon-wrapper {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    backdrop-filter: blur(10px);
}

.header-card h3 {
    color: white;
    margin: 0;
}

.header-card p {
    color: rgba(255, 255, 255, 0.9);
}

/* Form Card */
.form-card {
    background: white;
    padding: 2.5rem;
    border-radius: 16px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}

.form-section {
    height: 100%;
}

.section-title {
    color: #2d3748;
    font-weight: 600;
    font-size: 1.1rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e2e8f0;
}

/* Custom Input Styles */
.custom-label {
    display: block;
    font-weight: 500;
    color: #4a5568;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
}

.custom-input {
    width: 100%;
    padding: 0.85rem 1rem;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    background: #fafafa;
}

.custom-input:focus {
    outline: none;
    border-color: #667eea;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-input::placeholder {
    color: #a0aec0;
}

textarea.custom-input {
    resize: vertical;
    min-height: 120px;
}

select.custom-input {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    padding-right: 2.5rem;
}

/* Info Box */
.info-box {
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    padding: 1.25rem;
    border-radius: 10px;
    display: flex;
    align-items: flex-start;
    border-left: 4px solid #f59e0b;
}

.info-box i {
    font-size: 1.5rem;
    margin-top: 0.1rem;
}

.info-box strong {
    color: #92400e;
    display: block;
}

.info-box p {
    color: #78350f;
    font-size: 0.9rem;
}

/* Buttons */
.button-row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    /* padding-top: 1rem; */
    /* border-top: 2px solid #e2e8f0; */
}

.btn-clear {
    padding: 0.85rem 2rem;
    border: 2px solid #e2e8f0;
    background: white;
    color: #718096;
    border-radius: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
}

.btn-clear:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
    color: #2d3748;
    transform: translateY(-1px);
}

.btn-create {
    padding: 0.85rem 2.5rem;
    border: none;
    background: linear-gradient(135deg, #6cbbe2 0%, #4ba295 100%);
    color: white;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 15px rgba(196, 196, 196, 0.3);
}

.btn-create:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(109, 109, 109, 0.4);
}

.btn-create:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
    box-shadow: none;
}

/* Responsive */
@media (max-width: 991px) {
    .form-card {
        padding: 1.5rem;
    }

    .header-card {
        padding: 1.5rem;
    }

    .button-row {
        flex-direction: column-reverse;
    }

    .btn-clear,
    .btn-create {
        width: 100%;
        justify-content: center;
    }
}
</style>
